<template>
    <div class="page flex-col">
        <div class="group_1 justify-between">
            <div></div>
            <div class="flex header-container justify-between">
                <img class="image_2" referrerpolicy="no-referrer" src="../../assets/homepage/header-logo.png" />
                <div class="menus justify-evenly">
                    <div
                        class="text_3"
                        v-for="menu in homeObj.menus"
                        :key="menu.id"
                        :class="{ active: homeObj.selected === menu.id }"
                        @click="homeObj.selected = menu.id"
                    >
                        <router-link :to="'/#' + menu.id">{{ menu.name }}</router-link>
                        <div class="border-bottom" v-if="homeObj.selected === menu.id"></div>
                    </div>
                </div>
            </div>
            <div class="box_2 flex-col">
                <router-link to="/#contact" class="text_9">
                    <span> 联系我们 </span>
                </router-link>
            </div>
        </div>
        <div class="group_7 flex-col" v-if="homeObj.configInfo" id="index">
            <el-carousel class="" arrow="never" interval="5000">
                <el-carousel-item v-for="item in homeObj.configInfo.headerImgs" :key="item">
                    <el-image
                        class="image_1"
                        referrerpolicy="no-referrer"
                        :src="requestDomain + item.url"
                        @click="openLink(item.jump_url)"
                        fit="cover"
                        loading="lazy"
                    />
                </el-carousel-item>
            </el-carousel>
            <div class="image-wrapper_10 justify-around" v-if="homeObj.configInfo.headerAdImgs.length > 0">
                <el-image
                    class="image_4"
                    referrerpolicy="no-referrer"
                    v-for="item in homeObj.configInfo.headerAdImgs"
                    :key="item.url"
                    :src="requestDomain + item.url"
                    @click="openLink(item.jump_url)"
                />
            </div>
            <span class="text_10" id="about">关于起重汇</span>
            <img class="image_7" referrerpolicy="no-referrer" src="../../assets/homepage/img-dot.png" />
            <span class="text_11"
                >起重汇位于中国起重机械之乡河南省长垣市，专注服务于起重行业23年，销售和服务网点遍布全国各地，致力于为工业企业提供起重搬运设备一站式采购解决方案</span
            >
            <div class="box_9 flex-row">
                <div class="block_1 flex-col" @mouseenter="handleMouseEnter(1)" @mouseleave="handleMouseLeave(1)">
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInDown"
                        leave-active-class="animate__animated animate__fadeOutUp"
                    >
                        <div v-if="!homeObj.show1" class="section_1-active flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">公司简介</span>
                                <span class="text_13">
                                    起重汇总部位于中国起重机械之都河南省长垣市，是一家专注服务于起重行业23年的平台型服务企业，致力于为全球工业企业提供全面、便捷的一站式采购解决方案
                                </span>
                            </div>
                        </div>
                    </Transition>
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInDown"
                        leave-active-class="animate__animated animate__fadeOutUp"
                    >
                        <div v-if="homeObj.show1" class="section_2 flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">公司简介</span>
                                <span class="text_13">
                                    起重汇总部位于中国起重机械之都河南省长垣市，是一家专注服务于起重行业23年的平台型服务企业，致力于为全球工业企业提供全面、便捷的一站式采购解决方案
                                </span>
                            </div>
                        </div>
                    </Transition>
                </div>
                <div class="block_2 flex-row" @mouseenter="handleMouseEnter(2)" @mouseleave="handleMouseLeave(2)">
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInDown"
                        leave-active-class="animate__animated animate__fadeOutUp"
                    >
                        <div v-show="!homeObj.show2" class="section_1-active section_2-active flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">公司使命</span>
                                <span class="text_13"> 轻松采购，使命必达 </span>
                            </div>
                        </div>
                    </Transition>
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInUp"
                        leave-active-class="animate__animated animate__fadeOutDown"
                    >
                        <div v-show="homeObj.show2" class="section_2 flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">公司使命</span>
                                <span class="text_13"> 轻松采购，使命必达 </span>
                            </div>
                        </div>
                    </Transition>
                </div>
                <div class="block_3 flex-col" @mouseenter="handleMouseEnter(3)" @mouseleave="handleMouseLeave(3)">
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInDown"
                        leave-active-class="animate__animated animate__fadeOutUp"
                    >
                        <div v-show="!homeObj.show3" class="section_1-active flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">企业愿景</span>
                                <span class="text_13"> 成为起重行业全品类性价比NO.1的供应链集团 </span>
                            </div>
                        </div>
                    </Transition>
                    <Transition
                        name="custom-classes"
                        enter-active-class="animate__animated animate__fadeInUp"
                        leave-active-class="animate__animated animate__fadeOutDown"
                    >
                        <div v-show="homeObj.show3" class="section_2 flex-row">
                            <div class="text-group_20 flex-col justify-between">
                                <span class="text_12">企业愿景</span>
                                <span class="text_13"> 成为起重行业全品类性价比NO.1的供应链集团 </span>
                            </div>
                        </div>
                    </Transition>
                </div>
            </div>
            <div class="section_3 flex-col" id="supply">
                <span class="text_18">供应链优势</span>
                <img class="image_8" referrerpolicy="no-referrer" src="../../assets/homepage/img-dot.png" />
                <span class="text_19">通过起重汇全产业链服务体系,帮助采购企业，降底采购成本5%至35%以上</span>
                <div class="grid_3 flex-row">
                    <div class="image-text_1 flex-col">
                        <img class="box_6" referrerpolicy="no-referrer" src="../../assets/homepage/icon-01.png" />
                        <div class="text-group_23 flex-col justify-between">
                            <span class="text_20">技术支持</span>
                            <span class="text_21">免费提供工厂前期车间规划及施工指导提供</span>
                        </div>
                    </div>
                    <div class="image-text_2 flex-col">
                        <img class="label_1" referrerpolicy="no-referrer" src="../../assets/homepage/icon-02.png" />
                        <div class="text-group_24 flex-col justify-between">
                            <span class="text_22">产品选型</span>
                            <span class="text_23">提供起重机选配方案,好用又省钱</span>
                        </div>
                    </div>
                    <div class="image-text_3 flex-col">
                        <img class="label_2" referrerpolicy="no-referrer" src="../../assets/homepage/icon-03.png" />
                        <div class="text-group_25 flex-col justify-between">
                            <span class="text_24">委托招标</span>
                            <span class="text_25">用专业的眼光货比多家,只选对的</span>
                        </div>
                    </div>
                    <div class="image-text_4 flex-col">
                        <img class="label_3" referrerpolicy="no-referrer" src="../../assets/homepage/icon-04.png" />
                        <div class="text-group_26 flex-col justify-between">
                            <span class="text_26">企业推荐</span>
                            <span class="text_27">择优推荐</span>
                        </div>
                    </div>
                    <div class="image-text_5 flex-col">
                        <img class="label_4" referrerpolicy="no-referrer" src="../../assets/homepage/icon-05.png" />
                        <div class="text-group_27 flex-col justify-between">
                            <span class="text_28">品类齐全</span>
                            <span class="text_29">提供从整机到配件、电气采购服务</span>
                        </div>
                    </div>
                    <div class="image-text_6 flex-col">
                        <img class="label_5" referrerpolicy="no-referrer" src="../../assets/homepage/icon-06.png" />
                        <div class="text-group_28 flex-col justify-between">
                            <span class="text_30">生产监理</span>
                            <span class="text_31">从订单到生产,物流运输全流程跟踪服务</span>
                        </div>
                    </div>
                </div>
                <div class="section_10 flex-row">
                    <div class="group_2 flex-row">
                        <div class="image-text_16 flex-col justify-between">
                            <img class="label_6" referrerpolicy="no-referrer" src="../../assets/homepage/icon-07.png" />

                            <div class="text-group_29 flex-col justify-between">
                                <span class="text_32">安装维修</span>
                                <span class="text_33">提供安装维修、设备迁移、常年驻厂维保服务</span>
                            </div>
                        </div>
                    </div>
                    <div class="group_3 flex-row">
                        <div class="image-text_17 flex-col justify-between">
                            <img class="label_7" referrerpolicy="no-referrer" src="../../assets/homepage/icon-08.png" />

                            <div class="text-group_30 flex-col justify-between">
                                <span class="text_34">全国服务</span>
                                <span class="text_35">服务范围覆盖国内多个地区及工业集聚区</span>
                            </div>
                        </div>
                    </div>
                    <div class="group_4 flex-row">
                        <div class="image-text_18 flex-col justify-between">
                            <img class="label_8" referrerpolicy="no-referrer" src="../../assets/homepage/icon-09.png" />
                            <div class="text-group_31 flex-col justify-between">
                                <span class="text_36">专属团队</span>
                                <span class="text_37">7*24小时服务,专属团队保驾护航</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section_5 flex-col" id="mobile">
                <span class="text_41">移动端服务</span>
                <img class="image_13" referrerpolicy="no-referrer" src="../../assets/homepage/img-dot__white.png" />
                <span class="text_42"
                    >为提升用户服务体验,起重汇为客户提供了PC端、微信小程序、抖音小程序等多端服务。请扫码访问我们的小程序,获取更多的服务内容和信息。</span
                >
                <div class="list_2 flex-row">
                    <div
                        class="list-items_3 flex-col justify-end"
                        v-for="(item, index) in homeObj.configInfo.prImgs"
                        :key="index"
                    >
                        <div class="image-wrapper_5 flex-col">
                            <img class="image_14" referrerpolicy="no-referrer" :src="requestDomain + item.url" />
                        </div>
                        <div class="text_43" v-html="item.jump_url"></div>
                    </div>
                </div>
            </div>
            <div class="section_4 flex-col" id="service">
                <span class="text_38">行业服务经验</span>
                <img class="image_9" referrerpolicy="no-referrer" src="../../assets/homepage/img-dot.png" />
                <span class="text_39">起重汇立促中国起重机械之乡，服务冶金、钢铁、机床、造纸等众多行业企业</span>
                <div class="grid_4 flex-row">
                    <div class="list-items_1 flex-col" v-for="(item, index) in homeObj.loopData0" :key="index">
                        <img class="label_9" referrerpolicy="no-referrer" :src="item.lanhuimage0" />
                        <span class="text_40" v-html="item.lanhutext0"></span>
                    </div>
                </div>
                <div class="image-wrapper_11 justify-around" v-if="homeObj.configInfo.footerImgs.length > 0">
                    <el-image
                        class="image_4"
                        referrerpolicy="no-referrer"
                        v-for="item in homeObj.configInfo.footerImgs"
                        :key="item.url"
                        :src="requestDomain + item.url"
                        @click="openLink(item.jump_url)"
                    />
                </div>
            </div>
            <div class="box_8 flex-col justify-end" id="contact">
                <div class="box_10 flex-row justify-between">
                    <div class="image-text_19 flex-row justify-between">
                        <img class="label_10" referrerpolicy="no-referrer" src="../../assets/homepage/icon-26.png" />
                        <div class="text-group_32 flex-col justify-between">
                            <span class="text_44">急速响应</span>
                            <span class="text_45">快速匹配供应商</span>
                        </div>
                    </div>
                    <img class="image_15" referrerpolicy="no-referrer" src="../../assets/homepage/gray-line.png" />
                    <div class="image-text_20 flex-row justify-between">
                        <img class="label_11" referrerpolicy="no-referrer" src="../../assets/homepage/icon-27.png" />
                        <div class="text-group_33 flex-col justify-between">
                            <span class="text_46">优采保障</span>
                            <span class="text_47">专用合同增开发票</span>
                        </div>
                    </div>
                    <img class="image_16" referrerpolicy="no-referrer" src="../../assets/homepage/gray-line.png" />
                    <div class="image-text_21 flex-row justify-between">
                        <img class="label_12" referrerpolicy="no-referrer" src="../../assets/homepage/icon-28.png" />
                        <div class="text-group_34 flex-col justify-between">
                            <span class="text_48">售后无忧</span>
                            <span class="text_49">专业售后增开发票</span>
                        </div>
                    </div>
                    <img class="image_17" referrerpolicy="no-referrer" src="../../assets/homepage/gray-line.png" />
                    <div class="image-text_22 flex-row justify-between">
                        <img class="label_13" referrerpolicy="no-referrer" src="../../assets/homepage/icon-29.png" />
                        <div class="text-group_35 flex-col justify-between">
                            <span class="text_50">专属客户</span>
                            <span class="text_51">采购过程全程把控</span>
                        </div>
                    </div>
                </div>
                <img class="image_18" referrerpolicy="no-referrer" src="../../assets/homepage/gray-line2.png" />
                <div class="box_11 flex-row">
                    <div class="block_5 flex-col justify-between">
                        <img
                            class="image_19"
                            referrerpolicy="no-referrer"
                            src="../../assets/homepage/footer-logo.png"
                        />
                        <span class="text_52"
                            >起重汇位于中国起重机械之乡河南省长垣市，专注服务于起重行业23年，销售和服务网点遍布全国各地，致力于为工业企业提供起重搬运设备一站式采购解决方案</span
                        >
                    </div>
                    <div class="block_6 flex-col justify-between">
                        <span class="text_53">微信小程序</span>
                        <div class="image-text_23 flex-col justify-end">
                            <div class="image-wrapper_6 flex-col">
                                <img
                                    class="image_20"
                                    referrerpolicy="no-referrer"
                                    :src="requestDomain + homeObj.configInfo.prImgs[0]?.url"
                                />
                            </div>
                            <span class="text-group_17">{{ homeObj.configInfo.prImgs[0]?.jump_url }}</span>
                        </div>
                    </div>
                    <div class="block_7 flex-col justify-between">
                        <span class="text_54">抖音小程序</span>
                        <div class="image-text_24 flex-col justify-end">
                            <div class="image-wrapper_7 flex-col">
                                <img
                                    class="image_21"
                                    referrerpolicy="no-referrer"
                                    :src="requestDomain + homeObj.configInfo.prImgs[1]?.url"
                                />
                            </div>
                            <span class="text-group_18">{{ homeObj.configInfo.prImgs[1]?.jump_url }}</span>
                        </div>
                    </div>
                    <div class="block_8 flex-col">
                        <div class="text-group_36 flex-col justify-between">
                            <span class="text_55">总部地址</span>
                            <span class="text_56">河南省长垣市国贸中心C座11层</span>
                        </div>
                        <span class="text_57">总部电话</span>
                        <a href="tel:4000373163">
                            <img
                                class="image-wrapper_12"
                                referrerpolicy="no-referrer"
                                src="../../assets/homepage/phone.png"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div class="text-wrapper_3">
                <div class="footer-container align-center justify-between">
                    <span class="text_58">
                        Copyright&nbsp;2014起重汇Co.,Ltd.All&nbsp;rights&nbsp;reserved.豫公网安备41910502000041号
                    </span>
                    <span class="text_59"
                        ><a href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2022028869号-2</a></span
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { reactive } from 'vue';
import request from '@/request/index';
import { requestDomain } from '../../../package.json';
const homeObj = reactive({
    show1: true,
    show2: true,
    show3: true,
    selected: 'index',
    menus: [
        {
            name: '首页',
            id: 'index'
        },
        {
            name: '关于我们',
            id: 'about'
        },
        {
            name: '供应链优势',
            id: 'supply'
        },
        {
            name: '移动端服务',
            id: 'mobile'
        },
        {
            name: '行业服务经验',
            id: 'service'
        }
    ],
    loopData0: [
        {
            lanhuimage0: require('../../assets/homepage/icon-10.png'),
            lanhutext0: '食品机械'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-11.png'),
            lanhutext0: '纺织服装'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-12.png'),
            lanhutext0: '机械制造'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-13.png'),
            lanhutext0: '汽车制造'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-14.png'),
            lanhutext0: '电力工程'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-15.png'),
            lanhutext0: '航空航天'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-16.png'),
            lanhutext0: '造纸工业'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-17.png'),
            lanhutext0: '化工石油'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-18.png'),
            lanhutext0: '轨道交通'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-19.png'),
            lanhutext0: '冶金铁钢'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-20.png'),
            lanhutext0: '船舶制造'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-21.png'),
            lanhutext0: '冶金矿产'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-22.png'),
            lanhutext0: '建筑建材'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-23.png'),
            lanhutext0: '水电工程'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-24.png'),
            lanhutext0: '风力风电'
        },
        {
            lanhuimage0: require('../../assets/homepage/icon-25.png'),
            lanhutext0: 'MORE'
        }
    ],
    configInfo: null
});
const openLink = url => {
    if (!url) return;
    window.open(url);
};

const fetchHomeData = async () => {
    const rsp = await request('fetchGlobalConfig', { type: 'pc' });
    if (rsp.data.length > 0) {
        homeObj.configInfo = JSON.parse(rsp.data[0].config_content);
    }
};

fetchHomeData();

const handleMouseEnter = type => {
    if (type === 1) {
        homeObj.show1 = false;
    } else if (type === 2) {
        homeObj.show2 = false;
    } else {
        homeObj.show3 = false;
    }
    console.log('mouse enter');
};

const handleMouseLeave = type => {
    if (type === 1) {
        homeObj.show1 = true;
    } else if (type === 2) {
        homeObj.show2 = true;
    } else {
        homeObj.show3 = true;
    }
};
</script>
<style scoped lang="scss">
@import url('./index.scss');
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
</style>
<style src="./common.css" />
